<style lang="css">
.table-header {
  margin: 10px 20px;
  /*height: 20px;*/
  vertical-align: middle;
  display: flex;
  align-items: center;
}

.table-header > img {
  display: inline-block;
  margin-right: 10px;
  cursor: pointer;
  vertical-align: middle;
}

.table-header .info-txt {
  display: inline-block;
  color: red;
  vertical-align: middle;
}

.left10 {
  margin-left: 10px;
}
</style>
<template>
  <div class="table-header">
    <img v-if="!isAcc" @click="$emit('add')" src="@/assets/images/common/icon_add.png"/>
    <img v-if="!isAcc" @click="$emit('remove')" src="@/assets/images/common/icon_remove.png"/>
    <img v-if="!isAcc" @click="$emit('copy')" src="@/assets/images/common/icon_copy.png"/>
    <Button v-if="batch && !isAcc" @click="batchAdd" type="primary" style="margin-right: 10px;border-radius: 5px;height: 30px;">
      批量填写
    </Button>
    <span v-if="txt && !isAcc" class="info-txt">{{ txt }}</span>
  </div>
</template>
<script>
export default {
  name: "TableHeader",
  props: {
    txt: {
      type: String,
      default: ''
    },
    batch: {
      type: Boolean,
      default: false,
    },
    isQiQi: {
      type: Boolean,
      default: false,
    },
    isAcc: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      switch1: true
    }
  },
  methods: {
    batchAdd() {
      this.$emit('batchAdd');
    },
    change(status) {
      this.$emit('setSwitch', status);
    }
  },
};
</script>